import React from "react";
import { SvgIconProps } from "@mui/material";
import { StaticIconStyle } from "./Common.style";

interface StaticIconProps {
  icon: React.ComponentType<SvgIconProps>;
  size: number;
}

export const StaticIcon = ({ icon: IconComponent, size }: StaticIconProps) => {
  return (
    <StaticIconStyle disableRipple data-testid="static-icon">
      <IconComponent
        sx={{
          color: "white",
          width: size,
          height: size,
        }}
      />
    </StaticIconStyle>
  );
};
